<template>
  <v-dialog
    v-model="dialogDetail"
    persistent
    max-width="1200px"
    transition="dialog-transition"
    v-if="dialogDetail"
    @keyup.esc="$emit('close')"
  >
  <v-card flat class="no__padding">
    <v-card-text>
      <div v-if="loadingDetail" class="pa-5">
        <Loader :loading="true" skin="light"></Loader>
      </div>
      <div v-else>
        <h2>Objednávka č. {{detailItem.cislo_nakupu}}</h2>
        <v-card class="grey lighten-4 mt-2" :class="{'pl-0 pr-O': $vuetify.breakpoint.smAndDown}">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                Datum: <strong>{{detailItem.datum | formatDate}}</strong>
              </v-flex>
              <v-flex xs12 sm6>
                Variabilní symbol: <strong>{{detailItem.variabilni_symbol}}</strong>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-4">
              <v-flex xs12 sm6>
                Stav: <strong>{{detailItem.stav_objednavky.nazev}}</strong>
              </v-flex>
              <v-flex xs12 sm6>
                Doručení: <strong v-if="detailItem.zpusob_doruceni!=null">{{detailItem.zpusob_doruceni.nazev}}</strong><strong v-else>--</strong>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="grey lighten-4 mt-3" :class="{'pl-0 pr-O': $vuetify.breakpoint.smAndDown}">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <h3>Fakturační adresa:</h3>
                <adresa-view :adresa="detailItem.fa_adresa" class="mt-2"></adresa-view>
              </v-flex>
              <v-flex xs12 sm6>
                <h3>Doručovací adresa:</h3>
                <adresa-view :adresa="detailItem.dod_adresa" class="mt-2"></adresa-view>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card color="grey lighten-4 mt-3" :class="{'pl-3 pr-3': $vuetify.breakpoint.smAndDown}">
          <h4 class="mx-0">Produkty v objednávce:</h4>
          <v-data-table
            :headers="detailProductsHeaders"
            :items="detailItem.polozky"
            hide-controls
            class="mt-2"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>
                  <router-link v-if="!props.item.postovne" :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">{{props.item.produkt.nazev}}</router-link>
                  <span v-else>Poštovné</span>
                </td>
                <td class="text-xs-right">
                  {{props.item.castka_mj | formatMoney}} {{props.item.mena.zkratka}}
                </td>
                <td class="text-xs-right">
                  <span v-if="props.item.sleva>0">{{props.item.sleva | formatMoney}} {{props.item.mena.zkratka}}</span>
                  <span v-else>--</span>
                </td>
                <td class="text-xs-right">
                  {{props.item.mnozstvi}} ks
                </td>
                <td class="text-xs-right">
                  <span v-if="props.item.castka_dph_10>0">{{props.item.castka_dph_10 | formatMoney}} {{props.item.mena.zkratka}}</span>
                  <span v-else-if="props.item.castka_dph_15>0">{{props.item.castka_dph_15 | formatMoney}} {{props.item.mena.zkratka}}</span>
                  <span v-else-if="props.item.castka_dph_21>0">{{props.item.castka_dph_21 | formatMoney}} {{props.item.mena.zkratka}}</span>
                  <span v-else>0 {{props.item.mena.zkratka}}</span>
                </td>
                <td class="text-xs-right">
                  <span v-html="computePrice(props.item.castka_mj - props.item.sleva, props.item.mnozstvi)"></span>&nbsp;{{props.item.mena.zkratka}}
                </td>
                <td class="text-xs-right">
                  {{props.item.kredity | formatDouble}} kr.
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td>Celkem bez DPH:</td>
                <td colspan="7" class="text-xs-right">
                  <span v-if="!computingError">{{detailItem.castka_celkem_bez_dph | formatMoney}} {{detailItem.mena.zkratka}}</span>
                  <span v-else>--</span>
                </td>
              </tr>
              <tr v-if="detailItem.castka_celkem_dph_10>0">
                <td>DPH 10%</td>
                <td colspan="7" class="text-xs-right">
                  <span v-if="!computingError">{{detailItem.castka_celkem_dph_10 | formatMoney}} {{detailItem.mena.zkratka}}</span>
                  <span v-else>--</span>
                </td>
              </tr>
              <tr v-if="detailItem.castka_celkem_dph_15>0">
                <td>DPH 15%</td>
                <td colspan="7" class="text-xs-right">
                  <span v-if="!computingError">{{detailItem.castka_celkem_dph_15 | formatMoney}} {{detailItem.mena.zkratka}}</span>
                  <span v-else>--</span>
                </td>
              </tr>
              <tr v-if="detailItem.castka_celkem_dph_21>0">
                <td>DPH 21%</td>
                <td colspan="7" class="text-xs-right">
                  <span v-if="!computingError">{{detailItem.castka_celkem_dph_21 | formatMoney}} {{detailItem.mena.zkratka}}</span>
                  <span v-else>--</span>
                </td>
              </tr>
              <tr>
                <td><strong>Celkem s DPH:</strong></td>
                <td colspan="7" class="text-xs-right">
                  <span v-if="!computingError"><strong>{{detailItem.castka_celkem | formatMoney}} {{detailItem.mena.zkratka}}</strong></span>
                  <span v-else>--</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card-text>
    <v-card-actions class="pb-3">
      <!-- <a :href="api_url + 'osoby/' + $props.id + '/jednorazove-nakupy/' + detailItem.id + '/pdf'" target="_blank" v-if="!loadingDetail"><v-btn color="primary" flat depressed class="ma-0"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout PDF objednávku</v-btn></a> -->
      <v-spacer></v-spacer>
      <!-- <v-btn color="primary" depressed @click="editClick(detailItem)"><v-icon>edit</v-icon> Upravit objednávku</v-btn> -->
      <v-btn color="grey lighten-3" depressed @click="dialogDetail=false">Zavřít</v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<script>
import Base from '@/pages/Base'
import RocniBonusy from '@/pages/Klienti/RocniBonusy'
import GrafSporeni from '@/pages/Klienti/GrafSporeni'
import Platby from '@/pages/Klienti/Platby'
import PredaneProdukty from '@/pages/Klienti/PredaneProdukty'
export default {
  extends: Base,
  data () {
    return {
      dialogDetail: true,
      loading: true,
      editMode: false,
      activeTab: 0,
      tabs: [ 'informace', 'platby', 'rocni_bonusy', 'graf_sporeni', 'predane_produkty' ],
      item: {},
      newItem: {},
      updating: false,
      loadingDetail: true,
      detailItem: null,
      computingError: false,
      polozka: null,
      polozkaCena: null,
      editMode: false,
      preneseni_dan_povinnost_invalid_1: false,
      preneseni_dan_povinnost_invalid_2: false,
      dialogRemove: false,
      dItem: null,
      postovne_vyber: [],
      postovne: null,
      detailProductsHeaders: [
        { text: "Produkt", value: "produkt", sortable: false },
        { text: "Cena/ks", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Sleva/ks", value: "id", sortable: false, width: 150, align: "right" },
        { text: "Počet ks", value: "pocet", sortable: false, width: 150, align: "right" },
        { text: "DPH celkem", value: "id", sortable: false, width: 150, align: "right" },
        { text: "Cena celkem s DPH", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Kredity MJ", value: "kredity", sortable: false, width: 150, align: "right" },
      ],
    }
  },
  computed: {
    api_url () {
      return window.api.$api_url;
    }
  },
  watch: {
    dialogDetail (v) {
      if (!v)
        this.$emit("close");
    }
  },
  props: {
    klient: [ String, Number ],
    id: [ String, Number ]
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load () {
      this.loadingDetail = true;
      window.api.get("osoby/" + this.$props.klient + "/jednorazove-nakupy/" + this.$props.id).then((_body) => {
        this.detailItem = _body;
        this.loadingDetail = false;
      }).catch((err) => {
        console.log(err);
        this.loadingDetail = false;
      });
    },
    computePrice(c, q) {
      if (c == null || q == null || c <= 0 || q <= 0)
        return 0;
      return window.th.formatPrice(c*q, 2, ",", " ").replace(" ", "&nbsp;")
    },
  },
  components: {
    RocniBonusy, Platby, PredaneProdukty, GrafSporeni
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/JednorazovyNakupDialog.vue